import { useCallback, useMemo } from "react";
import * as PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Search from "../../basicComponents/Searchv2/Searchv2";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "../../messages/messages";
import moment from "moment";
import { withRouter } from "react-router";
import message from "containers/Dashboard/messages";
import SubHeader from "basicComponents/SubHeader/SubHeader";

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },

  messageWrapper: {
    width: "100%",
    height: "100%",
  },

  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    fontWeight: 500,
    fontSize: "1.5rem",
  },

  badge: {
    backgroundColor: "#ff6a55",
    borderRadius: "50%",
    color: "#ffffff",
    height: "100%",
    width: "1.5rem",
    textAlign: "center",
    marginLeft: "5px",
    fontSize: "16px",
    border: "solid 1px rgb(0,0,0,0.24)",
    lineHeight: "20px",
  },
  subHeader: {
    fontSize: "14px",
    textAlign: "center",
  },
  container: {},
  wrapperHeader: { paddingBottom: "2px" },
  contentWrapper: {},
  openMessages: { fontSize: "14px" },

  headerText: {
    cursor: "pointer",
  },
}));

function MessageOverview({
  messages,
  onFilterChange,
  practice,
  filter,
  status,
  statusOpenCount,
  history,
}) {
  const classes = useStyles();

  const handleArrowMessageClicked = useCallback(
    () => {
      history.push("/dashboard/practice/messages");
    },
    [history],
  );

  // map or change in backend?
  const dateFormatChanged = useMemo(
    () =>
      messages.map(m => ({
        ...m,
        dateUpdated: moment.unix(m.updatedAt).fromNow(),
      })),
    [messages],
  );

  const handleMessageClicked = useCallback(
    (e, column) => {
      const clickedMessage = column.original;
      history.push({
        pathname: `/dashboard/practice/messages/${clickedMessage.id}`,
        state: {
          filter,
          status,
          activeMessageId: clickedMessage.id,
        },
      });
    },
    [filter, history, status],
  );

  return (
    <div className={classes.wrapper}>
      <div className={classes.wrapperHeader}>
        <div className={classes.header} data-cy="headerMessages">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className={classes.headerText}
            onClick={() => history.push("/dashboard/practice/messages")}
          >
            <FormattedMessage {...message.dashboard_messages} />
          </div>
          {statusOpenCount !== 0 && (
            <div className={classes.badge} data-cy="badgeMessages">
              {statusOpenCount || "0"}
            </div>
          )}
        </div>
        <SubHeader extraMargin center>
          {`${statusOpenCount} ` || "0 "}
          <FormattedMessage {...message.openMessage} />
        </SubHeader>
      </div>

      <div className={classes.contentWrapper}>
        <Search
          enableIcons={false}
          icons={[]}
          id="MessagesSearch"
          arrowId="messagesArrowButton"
          items={dateFormatChanged}
          placeholder={GlobalMessages.search_messages}
          value={filter}
          practice={practice}
          onChange={e => onFilterChange(e.target.value)}
          showArrow
          handleArrowClicked={handleArrowMessageClicked}
          showTableContent
          height={180}
          onClick={handleMessageClicked}
          headers={[
            {
              Header: <FormattedMessage {...GlobalMessages.topic} />,
              accessor: "topic",
              minWidth: 150,
            },
            {
              Header: <FormattedMessage {...GlobalMessages.date} />,
              accessor: "dateUpdated",
              minWidth: 100,
            },
          ]}
        />
      </div>
    </div>
  );
}

MessageOverview.propTypes = {
  filter: PropTypes.string,
  status: PropTypes.any,
  messages: PropTypes.array,
  onFilterChange: PropTypes.func,
  practice: PropTypes.object,
  statusOpenCount: PropTypes.number,
  history: PropTypes.object,
};

export default withRouter(MessageOverview);
